module.exports = __webpack_public_path__ + "img/product-tutorial-4-music-bee.98ac00f3.svg";